import { SettingsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import FinancialAccountGroupModel from "models/Settings/Financial/FinancialAccountGroupModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<FinancialAccountGroupModel> => {
    return await axios.delete(
      `${SettingsEndpoint.SETTINGS_FINANCIAL_ACCOUNT_GROUP}/${id}`
    );
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<FinancialAccountGroupModel[]> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_FINANCIAL_ACCOUNT_GROUP, {
        params,
      })
      .then(({ data }) => data.items);
  };

export const create =
  (axios: AxiosInstance) =>
  async (
    data: FinancialAccountGroupModel
  ): Promise<FinancialAccountGroupModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_FINANCIAL_ACCOUNT_GROUP, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (
    data: FinancialAccountGroupModel
  ): Promise<FinancialAccountGroupModel> => {
    return await axios
      .put(
        `/${SettingsEndpoint.SETTINGS_FINANCIAL_ACCOUNT_GROUP}/${data.id}`,
        data
      )
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<FinancialAccountGroupModel> => {
    return await axios
      .patch(`/${SettingsEndpoint.SETTINGS_FINANCIAL_ACCOUNT_GROUP}/${id}`)
      .then(({ data }) => data);
  };
